"use strict";

import IQBPaymentsDetails from "../models/IQBPaymentsDetails";
import { v1 } from "uuid";
import ky from "ky";

const createAToken = async (chargeType: "card" | "bankAccount", details: IQBPaymentsDetails): Promise<string> => {
    try {
        let endpoint = "https://api.intuit.com";

        if (document.domain !== "app.orderwerks.com") {
            endpoint = "https://sandbox.api.intuit.com";
        }

        if (chargeType) {
            // TODO
        }

        const url = `${endpoint}/quickbooks/v4/payments/tokens`;

        return ky
            .post<{ cardToken: { data: { value: string } } }>(url, {
                headers: {
                    "request-id": v1(),
                },
                json: details,
            })
            .then(async (res) => {
                const data = await res.json();

                return data.value;
            });
    } catch (err) {
        console.log(err);
        throw err;
    }
};

const QuickbooksPaymentsService = {
    createAToken,
};

export default QuickbooksPaymentsService;
